import SubtitleAndDescription from "components/Common/SubtitleAndDescription";
import { Abilities, Item } from "./BuildPageContainer";
import BuildStage from "./BuildStage";
import UnlockOrder from "./UnlockOrder";

interface BuildSummaryProps {
  winRate: number;
  matches: number;
  barColors: { [key: string]: number };
  abilitiesByPickOrder: { abilityName: string }[];
  abilitiesBySlot: Abilities;
  finalBuild: Item[];
}

const BuildSummary = (props: BuildSummaryProps) => {
  const { winRate, matches, barColors, abilitiesByPickOrder, abilitiesBySlot, finalBuild } = props;

  const orangeBarStat = barColors?.weapon > 1 ? 1 : barColors?.weapon;
  const purpleBarStat = barColors?.spirit > 1 ? 1 : barColors?.spirit;
  const greenBarStat = barColors?.vitality > 1 ? 1 : barColors?.vitality;

  const orangeBarWidth = (orangeBarStat ?? 0) * 100 + "%";
  const purpleBarWidth = (purpleBarStat ?? 0) * 100 + "%";
  const greenBarWidth = (greenBarStat ?? 0) * 100 + "%";

  return (
    <div className="build-summary-wrapper">
      <SubtitleAndDescription subtitle="Build Summary" />
      <div className="build-stats">
        {(winRate * 100).toFixed(1)}% WR <span className="match-count">({matches} Matches)</span>
      </div>
      <div className="build-summary">
        <div className="section-container">
          <div className="section-label">Damage Split</div>
          <div className="percentage-bars-container">
            <div className="percentage-bar-bg">
              <div className="percentage-bar-fg orange" style={{ width: orangeBarWidth }} />
            </div>
            <div className="percentage-bar-bg">
              <div className="percentage-bar-fg green" style={{ width: greenBarWidth }} />
            </div>
            <div className="percentage-bar-bg">
              <div className="percentage-bar-fg purple" style={{ width: purpleBarWidth }} />
            </div>
          </div>
        </div>
        <div className="section-container">
          <div className="section-label">Unlock Order</div>
          <UnlockOrder abilitiesByPickOrder={abilitiesByPickOrder} abilitiesBySlot={abilitiesBySlot} />
        </div>
        <BuildStage baseItems={finalBuild} />
        <div className="section-container import-button-container">
          <div className="section-label">Build Importer</div>
          <div className="import-button">SOON™</div>
        </div>
      </div>
    </div>
  );
};

export default BuildSummary;
